import { render, staticRenderFns } from "./addFaxDetectRouteOptions.vue?vue&type=template&id=65ca28c9&"
import script from "./addFaxDetectRouteOptions.vue?vue&type=script&lang=js&"
export * from "./addFaxDetectRouteOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports